import React, { useState } from 'react';
import { Box, Text, Input, Button, Flex } from '@chakra-ui/react';
import { Header } from '../components/Header';
import { useNavigate } from 'react-router-dom';
export function ForgotPage() {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const handleRemindMe = () => {
    // Submit logic placeholder
    console.log('Sending reset email to:', email);
  };
  return <Box w="100vw" h="100vh" bg="white" overflow="auto" data-id="element-284">
      <Header data-id="element-285" />

      <Box pt="64px" px={6} py={6} data-id="element-286">
        <Box border="2px solid #006666" borderRadius="md" bg="white" maxW="620px" p={6} className="ml-[37px] mt-[100px] mb-[100px]" data-id="element-287">
          {/* Heading */}
          <Text fontSize="xl" fontWeight="bold" color="black" mb={2} data-id="element-288">
            Forgot Your Password?
          </Text>

          {/* Description */}
          <Text fontSize="md" color="black" mb={4} lineHeight="1.5" data-id="element-289">
            Enter the email address linked to your account and you will recieve
            an email containing a link to reset your password.
          </Text>

          {/* Email input — yellow background */}
          <Input placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} type="email" bg="#FFFF99" border="1px solid" borderColor="purple.300" focusBorderColor="purple.500" _hover={{
          borderColor: 'purple.400'
        }} _placeholder={{
          color: 'gray.500'
        }} borderRadius="sm" fontSize="md" mb={6} maxW="340px" data-id="element-290" />

          {/* Buttons */}
          <Flex gap={3} justify="center" data-id="element-291">
            <Button bg="gray.500" color="white" _hover={{
            bg: 'gray.600'
          }} _active={{
            bg: 'gray.700'
          }} borderRadius="md" px={6} fontSize="md" fontWeight="semibold" onClick={() => navigate('/login')} data-id="element-292">
              Cancel
            </Button>
            <Button bg="#9BAEE8" color="white" _hover={{
            bg: '#8A9FE0'
          }} _active={{
            bg: '#7A8FD0'
          }} borderRadius="md" px={6} fontSize="md" fontWeight="semibold" onClick={handleRemindMe} data-id="element-293">
              Remind Me
            </Button>
          </Flex>
        </Box>
      </Box>
    </Box>;
}